import * as T from '../types/store.types';
import { EVENTS } from '../settings';

export const reducer = (state: T.IState, action: T.IAction = {}) => {
  switch (action.type) {
    case EVENTS.CHANGE: {
      return {
        ...state,
        ...action.state,
      };
    }

    case EVENTS.SUBSCRIBE: {
      return {
        ...state,
        isSubscribed: true,
        subscription: action.subscription,
      };
    }

    case EVENTS.UNSUBSCRIBE: {
      return {
        ...state,
        isSubscribed: false,
        subscription: undefined,
      };
    }

    case EVENTS.READY: {
      return {
        ...state,
        ...action.state,
        isReady: true,
      };
    }

    default: {
      return state;
    }
  }
};
